import { faBed, faCalendarAlt, faEllipsisVertical, faSearch, faVenus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Card, Col, Container, Dropdown, Form, Image, Row } from "react-bootstrap";
import * as Constants from '../../../Helper/constants/constants';
import WithoutImageHeader from "../../../Helper/withoutImageHeader";
import { Build_Img } from "../../../../assets/images";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";

const Viewfile = () => {

    const [breadcrumData, setbreadcrumData] = useState(['Screen']);
    const [selectedDocs, setSelectedDocs] = useState([]);
    var breadcrumItem = 'View File';

    console.log(selectedDocs, "<----------doc-------");

    return (
        <>
            <div className="role_list_screen ward_list_area">
                <WithoutImageHeader
                    header={Constants.VIEWFILE}
                    breadcrumData={breadcrumData}
                    breadcrumItem={breadcrumItem}
                />
                <Container>
                    <Row>
                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                            <div className="role_list_details">
                                <div className="title_btn_area">
                                    <div className="left_area">
                                        <p>
                                            {selectedDocs && selectedDocs[0]
                                                && selectedDocs[0].name ? selectedDocs[0].name
                                                : null}
                                        </p>
                                    </div>
                                    <div className="right_area">
                                        <a
                                            className="btn btn-primary"
                                            href="/add-Ward"
                                        >
                                            Download
                                        </a>
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        <input
                                            type="file"
                                            accept=".pdf , .doc, .docx , .jpg , jpeg , .xlsx ,xls"
                                            onChange={(e) =>{
                                                setSelectedDocs(Array.from(e.target.files))
                                            }}
                                        />
                                        <DocViewer
                                        
                                            documents={ selectedDocs && selectedDocs.map((file) => ({
                                                uri: window.URL.createObjectURL(file),
                                                fileName: file.name,
                                                fileType:file.type
                                            }))}
                                            pluginRenderers={DocViewerRenderers}
                                        />
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>

        </>
    )
}

export default Viewfile;